import { useEffect, useState } from "react";
import styles from "./session.module.scss";
function ContactDetailsComponent() {

    return (
        <>
            <div className={styles.sessionBody}>
                <div className={styles.innerTitle}>Basic Details</div>
                <div className={styles.detailsArea}>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Name</div>
                        <div className={styles.dtright}>Johny Wade</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Customer ID</div>
                        <div className={styles.dtright}>2112032819</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Session ID</div>
                        <div className={styles.dtright}>4562534647</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Session status</div>
                        <div className={styles.dtright}>Resolved</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Enter external Session ID</div>
                        <div className={styles.dtright}>aaa4d88e-1460-4795-a85d-2f3b4fc61ecb</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Session ID</div>
                        <div className={styles.dtright}>4562534647</div>
                    </div>
                </div>
                <div className={styles.innerTitle}>User Properties</div>
                <div className={styles.detailsArea}>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Phone Number</div>
                        <div className={styles.dtright}>90866 74658</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Email Id</div>
                        <div className={styles.dtright}>Convocate898@rediel.com</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Network Type</div>
                        <div className={styles.dtright}>Online</div>
                    </div>
                    <div className={styles.basicDetails}>
                        <div className={styles.dtleft}>Total Sessions</div>
                        <div className={styles.dtright}>4</div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ContactDetailsComponent;